/**
 * @sync-target レクシンユーザーメッセージ一覧 > 05_静的ページメッセージ
 */
export const STATIC_PAGE_MESSAGES = {
  NOT_FOUND: "404 - お探しのページは見つかりませんでした。",
  SPACE_NOT_FOUND: "スペースが見つかりませんでした",
  LOADING: "読み込み中...",
  REVERSE_ENGINEERING_PROCESSING_DELAY_WARNING:
    "処理に時間がかかっています。しばらくお待ちください。",
} as const;
